import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

const Loading = ({ classes }) => (
  <div className={classes.container} data-testid="loading">
    <CircularProgress />
  </div>
);

Loading.propTypes = {
  classes: PropTypes.shape({}),
};

Loading.defaultProps = {
  classes: {},
};

export default Loading;
